import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  // apiKey: "AIzaSyC18DjHswIPBx37oLbpIzVxKYf6T0dfF2I",
  // authDomain: "eroapp-f1167.firebaseapp.com",
  // projectId: "eroapp-f1167",
  // storageBucket: "eroapp-f1167.appspot.com",
  // messagingSenderId: "668284969263",
  // appId: "1:668284969263:web:2c3dc65eb12f0a1b6841da",
  apiKey: "AIzaSyBXWVEKFrIe15TkKrTecRBff40v2_JXm6U",
  authDomain: "eroapp-56eeb.firebaseapp.com",
  projectId: "eroapp-56eeb",
  storageBucket: "eroapp-56eeb.firebasestorage.app",
  messagingSenderId: "550921559249",
  appId: "1:550921559249:web:51bee393a9bce24bdbf9f0",
};

let app;
if (firebase.apps.length === 0) {
  app = firebase.initializeApp(firebaseConfig);
  firebase.firestore().settings({ experimentalForceLongPolling: true });
} else {
  app = firebase.app();
}

const auth = firebase.auth();
const db = getFirestore(app);
const storage = firebase.storage();

export { auth, db, storage };
